var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"balance-item"},[_c('div',{staticClass:"no-wrap-container"},[_c('span',{staticClass:"cash-amount"},[_vm._v(" "+_vm._s(_vm.cashAmount >= 0 ? '+' : "-")+"$"+_vm._s(_vm._f("currencyNoSymbol")(Math.abs(_vm.cashAmount || 0)))+" ")])]),_c('div',{staticClass:"label center-in-page"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }